import { useContext, useEffect, useState } from 'react';
import { ProgressContext } from '../../../Context/progressContext';
import { RequestNextApi } from '../../../../api/Request';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import { getCookie } from '../../../../utils/cookieHandle';
import AcknowledgementSlides from './AcknowledgementSlides';
import useRecertificationSlides from './hooks/useRecertificationSlides';

export default function Recertification({ userId }) {
    const { update: updateProgress } = useContext(ProgressContext);

    const setSlides = useRecertificationSlides((state) => state.setSlides);
    const setTotalSlides = useRecertificationSlides((state) => state.setTotalSlides)

    const setFbiFields = useRecertificationSlides((state) => state.setFbiFields);
    const resetAllFields = useRecertificationSlides((state) => state.resetAllFields);

    const [canRenewCertification, setCanRenewCertification] = useState(null);

    useEffect(() => {
        const initPage = async () => {
            try {
                resetAllFields?.()
                updateProgress({ isLoading: true });
                const result = await RequestNextApi.post('/cka/user-fetch-cka', {
                    jwtToken: getCookie('jwt-token'),
                    ...(userId ? { userId } : {}),
                });
                if (result.data.success) {
                    setCanRenewCertification(result.data.user.canRenewCertification);

                    const toSaveInFbiFields = {
                        fbiSearch: result.data.user?.fbiSearch || 0,
                        fbiClient: result.data.user?.fbiClient || "",
                        fbiExperience: result.data.user?.fbiExperience || "",
                        fbiTraining: result.data.user.fbiTraining ? result.data.user.fbiTraining.split('|') : [],
                    }
                    setFbiFields(toSaveInFbiFields)

                    if (result.data.user.canRenewCertification) {
                        fetchSections();
                    }
                } else {
                    ShowNotification.error(result.data.message);
                }
            } catch (e) {

            } finally {
                updateProgress({ isLoading: false });
            }
        };
        initPage();
        return () => {
            resetAllFields?.()
        }
    }, []);

    const fetchSections = async () => {
        try {
            updateProgress({ isLoading: true });
            const result = await RequestNextApi.post('/recertification/fetch-recertification', {
                jwtToken: getCookie('jwt-token'),
                ...(userId ? { userId } : {}),
            });
            if (result.data.success) {
                setSlides([...result.data.sections.map(i => ({
                    ...i,
                    ...(i.sectionTitle === "Kingdom Advisors Faith-Based Investing Attestation (Available Option for Investment Professionals)" ? {
                        requiresConfirmation: false,
                    } : {}),
                })), { sectionTitle: 'Requirements Met', requiresConfirmation: false, submissionStep: true }]);
                setTotalSlides(result.data.sections.length);
            }
        } catch (error) {
            ShowNotification.error('Fetching page failed');
        } finally {
            updateProgress({ isLoading: false });
        }
    };

    if (canRenewCertification === null) return <></>;

    return (
        <div>
            {!canRenewCertification ? (
                <div>
                    <div className='font-bold mt-5'>You may not renew your CKA designation at this time. Designation renewals may be performed up to 30 days in advance of expiration.</div>
                </div>
            ) :
                <AcknowledgementSlides />
            }
        </div>
    );
}
